module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch",
    class: {
      'no-action': _vm.disabled
    },
    style: (_vm.marginTop)
  }, [_c('input', {
    class: {
      'no-action': _vm.disabled, 'cmn-toggle cmn-toggle-round-flat': _vm.isInList === false, 'list-toggle list-toggle-round-flat': _vm.isInList
    },
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "id": _vm.identification,
      "formControlName": _vm.identification
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.changeFn
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'no-action': _vm.disabled
    },
    staticStyle: {
      "margin-bottom": "0 !important"
    },
    attrs: {
      "for": _vm.identification
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44c431c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/public/components/Switch.vue
// module id = 673
// module chunks = 0